import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRealtyStore } from '../../../../stores/realty-store';
import { useId } from 'react';
import {
  formatRealtyFilterNumber,
  KOSICEREAL_REALTY_FILTER_RECIPE,
  type RealtyFilterTemplateSetting,
} from '../realty-filter-recipe';
import styles from '../realty-filter.module.css';
import { RealtyFilterRange } from './utils/realty-filter-range';

type RealtyFilterAreaProps = {
  templateSetting?: RealtyFilterTemplateSetting;
};

export const RealtyFilterArea = ({ templateSetting }: RealtyFilterAreaProps) => {
  const { t } = useTranslations();
  const { setFilter, filter } = useRealtyStore();
  const instanceId = useId();
  const headingId = `${instanceId}-realty-filter-area-heading`;
  const { min, max, step } = KOSICEREAL_REALTY_FILTER_RECIPE.area;
  const heading = t('text1180');
  const formatArea = (area: number) => `${formatRealtyFilterNumber(area)} m²`;

  if (templateSetting && !templateSetting.enabled) {
    return null;
  }

  return (
    <div className={styles.fieldGroup} style={{ order: templateSetting?.order }}>
      <section className={`${styles.section} ${styles.areaSection}`} aria-labelledby={headingId}>
        <h2 id={headingId} className={`${styles.heading} ${styles.areaHeading}`}>
          {heading} m<sup>2</sup>
        </h2>
        <RealtyFilterRange
          ariaLabel={`${heading} m²`}
          bounds={[min, max]}
          rangeLabels={[t('text1427'), t('text86')]}
          unboundedLabel={t('text4019')}
          step={step}
          value={[filter.area_from, filter.area_to]}
          formatAccessibleValue={formatArea}
          renderValue={area => (
            <span className={styles.areaValue}>
              {formatRealtyFilterNumber(area)} m<sup>2</sup>
            </span>
          )}
          onCommit={([from, to], [, effectiveMaximum]) =>
            setFilter({
              area_from: from,
              area_to: to === effectiveMaximum ? undefined : to,
            })
          }
        />
      </section>
      <Separator className={styles.separator} />
    </div>
  );
};
